// extracted by mini-css-extract-plugin
export default {"newsItem":"ListItem_newsItem__kx8J4"};